import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Events from "./pages/Events";
import Shop from "./pages/Shop";
import FlyMuse from "./pages/FlyMuse";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/events" element={<Events />} />
                        <Route path="/shop" element={<Shop />} />
                        <Route path="/fly-muse" element={<FlyMuse />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
